import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Styled from './OutlinedButton.styled';

const OutlinedButton = (props) => {
  const {
    classes,
    className,
    isDisabled,
    children,
    variant,
    ...passThroughProps
  } = props;

  return (
    <Styled.OutlinedButtonComponent
      className={classnames(className, classes.root)}
      disabled={isDisabled}
      variant={variant}
      {...passThroughProps}>
      {children}
    </Styled.OutlinedButtonComponent>
  );
};

OutlinedButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'slighter']),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

OutlinedButton.defaultProps = {
  className: '',
  classes: {
    root: '',
  },
  isDisabled: false,
  children: null,
  variant: 'primary',
};

export default OutlinedButton;
